import * as React from "react";
import './Screenshot.scss'
import {WebShareController} from "../../../Controller/3DController/WebShareController";
import {IScreenshot, ScreenshotController} from "../../../Controller/3DController/ScreenshotController";
import {ConfiguratorModel} from "../../../Controller/3DController/ConfiguratorModel";
import  axios from "axios"
import {nameMap} from "../../../Controller/3DController/ModelLoad/ModelLoadController";
import {trackCTA, trackDownload, trackShare} from "../../../Controller/Tracking";
import { getWhiteLabel } from "../../../whitelabel";
import { translate } from "../../../Controller/3DController/translateController";
import { Camera, Close, Download, Envelope, Facebook, Share, Text, Twitter } from '../Icons/Icons';

// HACK: Buffer is not included by node anymore
(window as any).Buffer = (window as any).Buffer || require('buffer').Buffer;

interface Props{
    screenshotService:ScreenshotController,
    shareService:WebShareController,
    modelController:ConfiguratorModel,
    xrActive:boolean,
    closeScreenshot:()=>void
}

interface State{
    share:any,
    subShareMenu:boolean,
    link:string,
    showText:boolean,
    lastScreenshot?: IScreenshot
}

export class Screenshot extends React.Component<Props,State> {

    constructor(props:Props){
        super(props);

        let carModel = nameMap[0];

        if (props.modelController) {
            const car = this.props.modelController.modelLoadController.getModel();
            if (car) {
                carModel = car;
            }
        }

        this.state = {
            share:null,
            subShareMenu:false,
            link: carModel.link,
            showText: true
        }
    }

    private takeScreenshot(){
        this.props.screenshotService.makeScreenshot().then((data)=>{
            this.setState({
                lastScreenshot: data as any,
                share:data[1]
            })
        })
    }

    private cancelScreenshot(){
        this.setState({
            share:null
        })
    }

    private share(){
        if(this.props.shareService.deviceCanShareFile()){
            const modelName = this.props.modelController.modelLoadController.getModelName();
            const studioName = getWhiteLabel().name;

            this.props.shareService.share(
                `Mi ${modelName} virtual`,
                `¡Mi Nuevo ${modelName} se verá así! Entra al ${studioName} de Volkswagen y descubre en Realidad Aumentada cómo se verá el tuyo.`,
                this.props.modelController.getConfigURL(),
                this.state.share.blob);
            trackShare("mobile sharing");
        }
    }

    private closeScreenshot(){
        this.props.closeScreenshot();
    }

    private shareLink(){
        if(this.props.shareService.deviceCanShare()){
            const modelName = this.props.modelController.modelLoadController.getModelName();
            const studioName = getWhiteLabel().name;

            this.props.shareService.share(
                `Mi ${modelName} virtual`,
                `¡Mi Nuevo ${modelName} se verá así! Entra al ${studioName} de Volkswagen y descubre en Realidad Aumentada cómo se verá el tuyo.`,
                this.props.modelController.getConfigURL());
            trackShare("mobile sharing");
        }
        else{
            this.setState({
                subShareMenu: !this.state.subShareMenu
            })
        }
    }

    private saveScreenshot(){
        var a = document.createElement('a');
        a.download = "screenshot.png";
        let url = window.URL.createObjectURL(this.state.share.blob);
        a.href = url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        trackDownload();
    }

    private FBshare(){
        //@ts-ignore
        const FB = window.FB;
        let blob = this.state.share.dataUrl;
        let url = this.props.modelController.getConfigURL();
        FB.getLoginStatus((response)=>{
            console.log("res",response);
            if (response.status === "connected") {
                this.postImageToFacebook(FB,response.authResponse.userID, response.authResponse.accessToken, "Taos", "image/png", blob, url);
            }else {
                FB.login(function (response) {
                    this.postImageToFacebook(FB,response.authResponse.userID, response.authResponse.accessToken, "Taos", "image/png", blob, url);
                }, {scope: "publish_to_groups"});
            }
        })
    }

    private postImageToFacebook(FB,userID, token, filename, mimeType, imageData, message) {
        var fd = new FormData();
        fd.append("access_token", token);
        fd.append("source", message);

        // Upload image to facebook without story(post to feed)
        axios.post("https://graph.facebook.com/"+userID+"/feed?access_token=" + token, fd, {headers:{
                processData: false,
                contentType: false,
                cache: false
            }}).then((data)=>{
            console.log("success: ", data);

            // Get image source url
            FB.api("/" + data.data.id + "?fields=images",
                function (response) {
                    if (response && !response.error) {
                        //console.log(response.images[0].source);

                        // Create facebook post using image
                        FB.api(
                            "/me/feed",
                            "POST",
                            {
                                "message": "",
                                "picture": response.images[0].source,
                                "link": window.location.href,
                                "name": 'Look at the cute panda!',
                                "description": message,
                                "privacy": {
                                    value: 'SELF'
                                }
                            },
                            function (response) {
                                if (response && !response.error) {
                                    /* handle the result */
                                    console.log("Posted story to facebook");
                                    console.log(response);
                                }
                            }
                        );
                    }
                }
            );
        })
    }

    /*
    camera corner
                <div className={"screenshot-corner-holder lower-corner"}>
                        <div className="corner-bottom-left"></div>
                        <div className="corner-bottom-right"></div>
                    </div>
                    <div className={"screenshot-corner-holder top-corner"}>
                        <div className="corner-top-left"></div>
                        <div className="corner-top-right"></div>
                 </div>
         */

    render() {
        return (
            <>
                <div className="vw-screenshot-cta">
                    <div
                        className="vw-screenshot-cta__button"
                        onClick={() => {
                            trackCTA(this.state.link);
                            window.open(this.state.link, "_blank");
                        }}
                    >
                        {translate("id_interested")}
                    </div>
                </div>

                {this.state.subShareMenu && (
                    <div className="vw-screenshot-submenu">
                        <div
                            className="vw-screenshot-submenu__item"
                            onClick={()=>{trackShare("facebook");window.open(("https://www.facebook.com/sharer.php?href="+this.props.modelController.getConfigURL()), "_blank")}}
                        >
                            <Facebook />
                        </div>
                        <div
                            className="vw-screenshot-submenu__item"
                            onClick={()=>{trackShare("twitter");window.open(("https://twitter.com/intent/tweet?text"+this.props.modelController.getConfigURL()), "_blank")}}
                        >
                            <Twitter />
                        </div>
                        <div
                            className="vw-screenshot-submenu__item"
                            onClick={()=>{trackShare("mail");window.open(("mailto:?subject=Mi "+ this.props.modelController.modelLoadController.getModelName() +" virtual&amp;body="+this.props.modelController.getConfigURL()), "_blank")}}
                        >
                            <Envelope />
                        </div>
                    </div>
                )}

                <div className="vw-screenshot-menu">
                    {!this.props.xrActive && (<div
                        className="vw-screenshot-menu__item"
                        onClick={this.takeScreenshot.bind(this)}
                    >
                        <Camera />
                    </div>)}
                    <div
                        className="vw-screenshot-menu__item"
                        onClick={this.closeScreenshot.bind(this)}
                    >
                        <Close />
                    </div>
                    <div
                        className={`vw-screenshot-menu__item ${this.state.subShareMenu ? 'selected' : ''}`}
                        onClick={this.shareLink.bind(this)}
                    >
                        <Share />
                    </div>
                </div>

                {this.state.share && (
                    <div className="vw-screenshot-holder">
                        <div className="vw-screenshot-holder__wrapper">
                            <img
                                className="vw-screenshot-holder__image"
                                src={this.state.share.dataUrl}
                            />
                            <div className="vw-screenshot-holder__menu">
                                <div
                                    className={`vw-screenshot-holder__menu-item action ${this.state.showText ? 'selected' : ''}`}
                                    onClick={() => {
                                        this.setState({
                                            share: this.state.lastScreenshot[this.state.showText ? 0 : 1],
                                            showText: !this.state.showText
                                        });
                                    }}
                                >
                                    <Text />
                                </div>
                                <div
                                    className="vw-screenshot-holder__menu-item"
                                    onClick={this.cancelScreenshot.bind(this)}
                                >
                                    <Close />
                                </div>
                                <div
                                    className="vw-screenshot-holder__menu-item action"
                                    onClick={this.saveScreenshot.bind(this)}
                                >
                                    <Download />
                                </div>

                                {this.props.shareService.deviceCanShareFile() && (
                                    <div
                                        className="vw-screenshot-holder__menu-item action"
                                        onClick={this.share.bind(this)}
                                    >
                                        <Share />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}
